
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "fee-paid",
components: {
XHeader,
},
data(){
return{
fee:[
{
feetype:'学费',
feenum:10000
},
{
feetype:'住宿费',
feenum:1800
},
],
loan:8000,
}
},
}



// WEBPACK FOOTER //
// ./src/components/FeePaid.vue